import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import siteMessage from "@insite/client-framework/SiteMessage";
import Modal, { ModalPresentationProps } from "@GeriMed/MobiusOverrides/Modal/Modal";
import { css } from "styled-components";
import themeColors from "@GeriMed/styles/variables";
import { Hidden } from "@insite/mobius/index";

const mapStateToProps = (state: ApplicationState) => {
    const adveritisingSettings : any = getSettingsCollection(state).adveritisingSettings;
    return {
        adveritisingSettings
    }
};

type Props = ReturnType<typeof mapStateToProps>;


const SESSION_KEYS = {
    POPUP: "adveritisingpopup",
    SETTINGS: "adveritisingpopupsetting",
};

export interface HeaderAdveritisingpopupStyles {
    modal: ModalPresentationProps;
}

export const headerAdveritisingpopupStyles: HeaderAdveritisingpopupStyles = {
    modal: {
        cssOverrides: {
            modalContainer: css`
                height: 100%;
                align-items: flex-start;
                justify-content: flex-start;
            `,
            modalBody: css`
                &[class*="ContentBody"] {
                    max-width: 100%;
                    width: auto;
                    border-radius: 0;
                    margin: auto 0 0;
                    border: 1px solid ${themeColors.lightGray};
                    box-shadow: 0 0 10px rgba(0, 0, 0, .4);
                    max-height: calc(100% - 5px);
                }
            `,
            scrim: css`
                background-color: rgba(0, 0, 0, 0.45);
                transition: none;
            `,
            modalTitle: css`
                padding: 30px 20px 0; 
                button[data-test-selector="modalCloseButton"] {
                    min-height: 0;
                    padding: 0 9px;
                    top: 2px;
                    right: 4px;
                    height: 24px;
                    span[class*="IconWrapper"] {
                        top: 0;
                        display: flex;
                    }
                    svg {
                        width: 20px;
                        height: 20px;
                    }
                }
            `,
            modalContent: css`
                padding: 0 20px 20px;
            `,
        }
    }
}


const styles = headerAdveritisingpopupStyles;

export const HeaderAdveritisingpopup = ({ adveritisingSettings}: Props) => {
    const [displayPopup, setDisplayPopup] = useState(false);
    
    useEffect(() => {
        const isPopupEnabled = adveritisingSettings.enableAdveritisingPopup;
        sessionStorage.setItem(SESSION_KEYS.SETTINGS, String(isPopupEnabled));

        const timer = setTimeout(() => {
            const isPopupAlreadyShown = sessionStorage.getItem(SESSION_KEYS.POPUP);
            const settings = sessionStorage.getItem(SESSION_KEYS.SETTINGS);

            if (
                window.innerWidth > 767 &&
                settings === "true" &&
                !isPopupAlreadyShown
            ) {
                sessionStorage.setItem(SESSION_KEYS.POPUP, "true");
                setDisplayPopup(true);
            }
        }, 5000); // Delay of 5 seconds

        return () => clearTimeout(timer); // Clean up timer on unmount
    }, [adveritisingSettings]);

    

    const closeModal = () => {
        sessionStorage.setItem(SESSION_KEYS.POPUP, "true");
        setDisplayPopup(false);
    }

    return (
        <Hidden below="md">
            <Modal
                isOpen={displayPopup}
                handleClose={closeModal}
                headline={false}
                {...styles.modal}    
            >
                    {siteMessage("GM_Adveritising_Popup")}
            </Modal>
        </Hidden>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(HeaderAdveritisingpopup),
    definition: {
        displayName: "Header Adveritising Popup",
        icon: "arrow-right-to-bracket",
        group: "Common",
    },
};

export default widgetModule;
